import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import { FIDELIZE_QUOTE_PATH, getFidelizeBidding } from 'services/conlicitaseg';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';

function useFidelizeLoginRedirect(): string | null {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { fidelize_login_redirect_pending } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  if (!fidelize_login_redirect_pending) return null;

  return getFidelizeBidding(profile, isOnlyConlicitaseg) ? FIDELIZE_QUOTE_PATH : null;
}

export default useFidelizeLoginRedirect;
